import toString from 'lodash/toString';
import lowerCase from 'lodash/lowerCase';
import clone from 'lodash/clone';
import isEmpty from 'lodash/isEmpty';
import { buildUrl, getDateMappedForAvailability, makeUrlValid } from './utility';
import ocassionVenueType from '../constants/ocassion-venuetype.json';
import kebabCase from 'lodash/kebabCase';
import {
    DESTINATION_WEDDING_MODEL,
    ELASTIC_API,
    MODELS,
    WHICH_SEARCH_SERVICE_TO_USE,
} from '../constants/constants';
import callApi, { callSelfAPI } from './apiCaller';
import { isServer } from './nextUtility';

const DISALLOWED_BY_ROBOTS_TXT_KEYS = [
    'page',
    'packagetypes',
    'min_price',
    'max_price',
    'min_capacity',
    'max_capacity',
    'availability',
    'venuetypes',
    'localities',
    'amenities',
    'occasions',
    'colors',
    'timings',
    'cities',
    'locations',
    'sort',
];

export const PHOTOGRAPHERS_MULTI_SELECT = ['service_types', 'locations'];

export const PHOTOGRAPHER_SINGLE_SELECT = ['sort'];
export const PHOTOGRAPHER_IS_SELECTED = ['budget', 'reviews', 'days', 'rating'];
export const PHOTOGRAPHER_DROPDOWN = [
    'min_price',
    'max_price',
    'min_reviews',
    'max_reviews',
    'min_rating',
    'max_rating',
    'max_days',
    'min_days',
];

const LEAD_FORM_FILTERS = {
    ocassions: 'last_search_occasion',
    max_price: 'last_search_budget_max',
    min_price: 'last_search_budget_min',
    venuetypes: 'last_search_venuetype',
    localities: 'last_search_location',
    amenities: 'last_search_amenity',
    packagetypes: 'last_search_packagetype',
    btnSource: 'btn_source',
};
const ENQUIRY_FORM_FILTERS = {
    ocassions: 'last_search_occasion',
    max_price: 'last_search_budget_max',
    min_price: 'last_search_budget_min',
    venuetypes: 'last_search_venuetype',
    localities: 'last_search_location',
    amenities: 'last_search_amenity',
    packagetypes: 'last_search_packagetype',
};

export const getVenueListQuery = (cityslug, keyword, query, code) => {
    let url = `search/venues`;
    if (keyword && keyword !== '') {
        if (code) {
            url = `${url}/${keyword}/${code}`;
        } else {
            url = `${url}/${toString(cityslug)}/${keyword}/list`;
        }
    } else {
        url = `${url}/${toString(cityslug)}/venues/list`;
    }
    let newQuery = clone(query);
    delete newQuery?.cityslug;
    delete newQuery?.url;
    // newQuery = getQueryString(query);
    // if (newQuery && newQuery !== '') {
    //     url = url+newQuery;
    // }
    //////////////////////////////////////////////////////////
    // newQuery = getQueryString(query);
    // if (newQuery && newQuery !== '') {
    //     url = `${url}${newQuery}`;
    // }
    // return url
    //////////////////////////////////////////////////////////
    const serializedQuery = serialize(newQuery);
    if (isEmpty(newQuery)) {
        return `${url}`;
    } else {
        return `${url}?${serializedQuery}`;
    }
};

export const getVendorListQuery = (vendorType, urlslug, query) => {
    let url = `search/vendors/${vendorType}`;
    let newQuery = clone(query);
    delete newQuery?.urlslug;
    delete newQuery?.query;
    delete newQuery?.cityslug;
    const serializedQuery = serialize(newQuery);
    if (isEmpty(newQuery)) {
        url = `${url}/${toString(urlslug)}/list`;
    } else {
        url = `${url}/${toString(urlslug)}/list?${serializedQuery}`;
    }
    if (query) {
        return `${url}`;
    }
};

export const getDestinationWeddingQuery = (vendorType, urlslug, query) => {
    let url = `search/vendors/${vendorType}`;
    let newQuery = clone(query);
    delete newQuery?.urlslug;
    delete newQuery?.query;
    delete newQuery?.cityslug;
    const serializedQuery = serialize(newQuery);
    if (isEmpty(newQuery)) {
        url = `${url}/${toString(urlslug)}/list`;
    } else {
        url = `${url}/${toString(urlslug)}/list?${serializedQuery}`;
    }
    if (query) {
        return `${url}`;
    }
};

const serialize = (obj) => {
    var str = [];
    for (var p in obj)
        if (obj.hasOwnProperty(p)) {
            str.push(encodeURIComponent(p) + '=' + encodeURIComponent(obj[p]));
        }
    return str.join('&');
};

export const getBaseFiltersByCityQuery = (cityslug, query) => {
    let url = `search/venues/${toString(cityslug)}/base-filters`;
    let newQuery = clone(query);
    // delete newQuery.cityslug;
    // delete newQuery.url;
    newQuery = getQueryString(query);
    if (newQuery && newQuery !== '') {
        url = `${url}${newQuery}`;
    }
    return url;
};

export const getVenueSearchQuery = (cityslug, keyword, query) => {
    let url = ``;
    if (keyword && keyword !== '') {
        url = `/${toString(cityslug)}/${keyword}`;
    } else {
        url = `/${toString(cityslug)}/venues`;
    }
    if (query && query !== '') {
        url = `${url}${query}`;
    }
    return url;
};

export const getQueryString = (query) => {
    if (isEmpty(query)) {
        return '';
    } else {
        return buildUrl(null, {
            queryParams: query,
        });
    }
};

export const getRestParamsRemovingUrlParams = (allFilters, urlParams) => {
    if (allFilters) {
        allFilters.occasions = '';
        allFilters.page = '';
        // if (!isEmpty(urlParams)) {

        //     if (urlParams.localities) {
        //         // if (allFilters?.localities.length > 1) {
        //             allFilters.localities = [...allFilters.localities].filter(item => item !== urlParams.localities);
        //         // }
        //     }
        //     if (urlParams.venuetypes) {
        //         // if (allFilters?.venuetypes.length > 1) {
        //             allFilters.venuetypes = [...allFilters.venuetypes].filter(item => item !== urlParams.venuetypes);
        //         // }
        //     }
        // }
    }
    return allFilters;
};

export const getBaseUrlFromParams = (urlParams, MODEL, currentUrl, selectedFrom) => {
    let url = '';
    if (MODEL && MODEL == DESTINATION_WEDDING_MODEL) {
        if (MODELS[MODEL].base_search_page_url) {
            url = MODELS[MODEL].base_search_page_url;
        } else {
            url = currentUrl;
        }
    } else {
        if (urlParams.occasions) {
            if (urlParams.venuetypes) {
                if (ocassionVenueType?.[urlParams.occasions]?.[urlParams.venuetypes]) {
                    url = `${urlParams.occasions}-${urlParams.venuetypes}`;
                } else {
                    url = 'venues';
                }
                // } else if (urlParams.localities) {
                //     url = `${urlParams.occasions}-venues-in-${urlParams.localities}`;
            } else {
                url = `${urlParams.occasions}-venues`;
            }
            // } else if (urlParams.venuetypes) {
            //     url = `${urlParams.venuetypes}`;
            // } else if (urlParams.localities) {
            //     url = `${urlParams.localities}-venues`;
        }
    }
    return url;
};

export const getBaseUrlPhotographerFromParams = (urlParams) => {
    let url = '';
    return url;
};

export const getAllFiltersAndUrlParamsv2 = (
    modelName,
    selectedFrom,
    selectedValue,
    selectionCriteria,
    urlParams,
    allFilters
) => {
    if (MODELS[modelName].DROPDOWN.includes(selectedFrom)) {
        if (selectionCriteria === 'select') {
            // if(urlParams.min_price) {
            urlParams[selectedFrom] = kebabCase(selectedValue);
            allFilters[selectedFrom] = selectedValue;
        } else {
            delete allFilters[selectedFrom];
        }
    } 
    else if (MODELS[modelName].SINGLE_SELECT.includes(selectedFrom)) {
        if (selectionCriteria === 'select') {
            // if(urlParams.min_price) {
            urlParams[selectedFrom] = kebabCase(selectedValue);
            allFilters[selectedFrom] = selectedValue;
        } else {
            delete allFilters[selectedFrom];
        }
    }  else if (MODELS[modelName].MULTI_SELECT.includes(selectedFrom)) {
        if (selectionCriteria === 'select') {
            // if (urlParams.venuetypes) {
            allFilters[selectedFrom].push(selectedValue);
            urlParams[selectedFrom] = kebabCase(selectedValue);
            // } else {
            //   urlParams.venuetypes = kebabCase(selectedValue);
            // }
        } else {
            if (urlParams[selectedFrom] === kebabCase(selectedValue)) {
                urlParams[selectedFrom] = '';
                if (allFilters[selectedFrom]) {
                    allFilters[selectedFrom] = allFilters[selectedFrom].filter(
                        (item) => item !== kebabCase(selectedValue)
                    );
                    urlParams[selectedFrom] = allFilters[selectedFrom].pop();
                }
            } else {
                if (allFilters[selectedFrom]) {
                    allFilters[selectedFrom] = allFilters[selectedFrom].filter(
                        (item) => item !== kebabCase(selectedValue)
                    );
                }
            }
        }
    }
    return { urlParams, allFilters };
};

export const getAllFiltersAndUrlParams = (
    selectedFrom,
    selectedValue,
    selectionCriteria,
    urlParams,
    allFilters
) => {
    if (selectedFrom === 'occasions') {
        if (selectionCriteria === 'select') {
            if (urlParams.occasions) {
                urlParams.occasions = kebabCase(selectedValue);
                // allFilters[selectedFrom] = selectedValue;
                urlParams.venuetypes = '';
                urlParams.localities = '';
                allFilters = null;
            } else {
                allFilters[selectedFrom] = selectedValue;
                urlParams.occasions = kebabCase(selectedValue);
            }
        } else {
            urlParams.occasions = '';
        }
    } else if (selectedFrom === 'packagetypes') {
        if (selectionCriteria === 'select') {
            // if(urlParams.packagetypes) {
            urlParams.packagetypes = kebabCase(selectedValue);
            allFilters[selectedFrom] = selectedValue;
            // }
        } else {
            delete allFilters[selectedFrom];
        }
    } else if (selectedFrom === 'min_price') {
        if (selectionCriteria === 'select') {
            // if(urlParams.min_price) {
            urlParams.min_price = kebabCase(selectedValue);
            allFilters[selectedFrom] = selectedValue;
            // }
        } else {
            delete allFilters['min_price'];
        }
    } else if (selectedFrom === 'max_price') {
        if (selectionCriteria === 'select') {
            // if(urlParams.max_price) {
            urlParams.max_price = kebabCase(selectedValue);
            allFilters[selectedFrom] = selectedValue;
            // }
        } else {
            delete allFilters[selectedFrom];
        }
    } else if (selectedFrom === 'min_capacity') {
        if (selectionCriteria === 'select') {
            // if(urlParams.min_capacity) {
            urlParams.min_capacity = kebabCase(selectedValue);
            allFilters[selectedFrom] = selectedValue;
            // }
        } else {
            delete allFilters[selectedFrom];
        }
    } else if (selectedFrom === 'max_capacity') {
        if (selectionCriteria === 'select') {
            // if(urlParams.max_capacity) {
            urlParams.max_capacity = kebabCase(selectedValue);
            allFilters[selectedFrom] = selectedValue;
            // }
        } else {
            delete allFilters[selectedFrom];
        }
    } else if (selectedFrom === 'venuetypes') {
        if (selectionCriteria === 'select') {
            // if (urlParams.venuetypes) {
            allFilters.venuetypes.push(selectedValue);
            urlParams.venuetypes = kebabCase(selectedValue);
            // } else {
            //   urlParams.venuetypes = kebabCase(selectedValue);
            // }
        } else {
            if (urlParams.venuetypes === kebabCase(selectedValue)) {
                urlParams.venuetypes = '';
                if (allFilters.venuetypes) {
                    allFilters.venuetypes = allFilters.venuetypes.filter(
                        (item) => item !== kebabCase(selectedValue)
                    );
                    urlParams.venuetypes = allFilters.venuetypes.pop();
                }
            } else {
                if (allFilters.venuetypes) {
                    allFilters.venuetypes = allFilters.venuetypes.filter(
                        (item) => item !== kebabCase(selectedValue)
                    );
                }
            }
        }
    }else if (selectedFrom === 'regions') {
        if (selectionCriteria === 'select') {
            // if (urlParams.regions) {
            allFilters.regions.push(selectedValue);
            urlParams.regions = kebabCase(selectedValue);
            // } else {
            //   urlParams.regions = kebabCase(selectedValue);
            // }
        } else {
            if (urlParams.regions === kebabCase(selectedValue)) {
                urlParams.regions = '';
                if (allFilters.regions) {
                    allFilters.regions = allFilters.regions.filter(
                        (item) => item !== kebabCase(selectedValue)
                    );
                    urlParams.regions = allFilters.regions.pop();
                }
            } else {
                if (allFilters.regions) {
                    allFilters.regions = allFilters.regions.filter(
                        (item) => item !== kebabCase(selectedValue)
                    );
                }
            }
        }
    }
    
    else if (selectedFrom === 'localities') {
        if (selectionCriteria === 'select') {
            // if (urlParams.localities) {
            allFilters.localities.push(selectedValue);
            urlParams.localities = kebabCase(selectedValue);
            // } else {
            //   urlParams.localities = kebabCase(selectedValue);
            // }
        } else {
            if (urlParams.localities === kebabCase(selectedValue)) {
                urlParams.localities = '';
                if (allFilters.localities) {
                    allFilters.localities = allFilters.localities.filter(
                        (item) => item !== kebabCase(selectedValue)
                    );
                    urlParams.localities = allFilters.localities.pop();
                }
            } else {
                if (allFilters.localities) {
                    allFilters.localities = allFilters.localities.filter(
                        (item) => item !== kebabCase(selectedValue)
                    );
                }
            }
        }
    } else if (selectedFrom === 'operating_cities') {
        if (selectionCriteria === 'select') {
            // if (urlParams.localities) {
            allFilters.operating_cities.push(selectedValue);
            urlParams.operating_cities = kebabCase(selectedValue);
            // } else {
            //   urlParams.operating_cities = kebabCase(selectedValue);
            // }
        } else {
            if (urlParams.operating_cities === kebabCase(selectedValue)) {
                urlParams.operating_cities = '';
                if (allFilters.operating_cities) {
                    allFilters.operating_cities = allFilters.operating_cities.filter(
                        (item) => item !== kebabCase(selectedValue)
                    );
                    urlParams.operating_cities = allFilters.operating_cities.pop();
                }
            } else {
                if (allFilters.operating_cities) {
                    allFilters.operating_cities = allFilters.operating_cities.filter(
                        (item) => item !== kebabCase(selectedValue)
                    );
                }
            }
        }
    } else if (selectedFrom === 'amenities') {
        if (selectionCriteria === 'select') {
            // if (urlParams.amenities) {
            allFilters.amenities.push(selectedValue);
            urlParams.amenities = kebabCase(selectedValue);
            // } else {
            //   urlParams.amenities = kebabCase(selectedValue);
            // }
        } else {
            if (urlParams.amenities === kebabCase(selectedValue)) {
                urlParams.amenities = '';
                if (allFilters.amenities) {
                    allFilters.amenities = allFilters.amenities.filter(
                        (item) => item !== kebabCase(selectedValue)
                    );
                    urlParams.amenities = allFilters.amenities.pop();
                }
            } else {
                if (allFilters.amenities) {
                    allFilters.amenities = allFilters.amenities.filter(
                        (item) => item !== kebabCase(selectedValue)
                    );
                }
            }
        }
    } else if (selectedFrom === 'availability') {
        if (selectionCriteria === 'select') {
            const selectedDateValue = getDateMappedForAvailability(selectedValue);
            // if (urlParams.availability) {
            allFilters.availability = selectedDateValue;
            urlParams.availability = kebabCase(selectedDateValue);
            // } else {
            //   urlParams.availability = kebabCase(selectedValue);
            // }
        } else {
            delete allFilters[selectedFrom];
        }
    }
    return { urlParams, allFilters };
};

export const getPhotographerAllFiltersAndUrlParams = (
    selectedFrom,
    selectedValue,
    selectionCriteria,
    urlParams,
    allFilters
) => {
    if (PHOTOGRAPHER_DROPDOWN.includes(selectedFrom)) {
        if (selectionCriteria === 'select') {
            // if(urlParams.min_price) {
            urlParams[selectedFrom] = kebabCase(selectedValue);
            allFilters[selectedFrom] = selectedValue;
        } else {
            delete allFilters[selectedFrom];
        }
    } else if (PHOTOGRAPHERS_MULTI_SELECT.includes(selectedFrom)) {
        if (selectionCriteria === 'select') {
            // if (urlParams.venuetypes) {
            allFilters[selectedFrom].push(selectedValue);
            urlParams[selectedFrom] = kebabCase(selectedValue);
            // } else {
            //   urlParams.venuetypes = kebabCase(selectedValue);
            // }
        } else {
            if (urlParams[selectedFrom] === kebabCase(selectedValue)) {
                urlParams[selectedFrom] = '';
                if (allFilters[selectedFrom]) {
                    allFilters[selectedFrom] = allFilters[selectedFrom].filter(
                        (item) => item !== kebabCase(selectedValue)
                    );
                    urlParams[selectedFrom] = allFilters[selectedFrom].pop();
                }
            } else {
                if (allFilters[selectedFrom]) {
                    allFilters[selectedFrom] = allFilters[selectedFrom].filter(
                        (item) => item !== kebabCase(selectedValue)
                    );
                }
            }
        }
    }
    return { urlParams, allFilters };
};

export const getVendorsAllFiltersAndUrlParams = (
    modelName,
    selectedFrom,
    selectedValue,
    selectionCriteria,
    urlParams,
    allFilters
) => {
    if (MODELS[modelName].DROPDOWN.includes(selectedFrom)) {
        if (selectionCriteria === 'select') {
            // if(urlParams.min_price) {
            urlParams[selectedFrom] = kebabCase(selectedValue);
            allFilters[selectedFrom] = selectedValue;
        } else {
            delete allFilters[selectedFrom];
        }
    } else if (MODELS[modelName].MULTI_SELECT.includes(selectedFrom)) {
        if (selectionCriteria === 'select') {
            // if (urlParams.venuetypes) {
            allFilters[selectedFrom].push(selectedValue);
            urlParams[selectedFrom] = kebabCase(selectedValue);
            // } else {
            //   urlParams.venuetypes = kebabCase(selectedValue);
            // }
        } else {
            if (urlParams[selectedFrom] === kebabCase(selectedValue)) {
                urlParams[selectedFrom] = '';
                if (allFilters[selectedFrom]) {
                    allFilters[selectedFrom] = allFilters[selectedFrom].filter(
                        (item) => item !== kebabCase(selectedValue)
                    );
                    urlParams[selectedFrom] = allFilters[selectedFrom].pop();
                }
            } else {
                if (allFilters[selectedFrom]) {
                    allFilters[selectedFrom] = allFilters[selectedFrom].filter(
                        (item) => item !== kebabCase(selectedValue)
                    );
                }
            }
        }
    }
    return { urlParams, allFilters };
};

export const getBasePageUrl = (cityslug, keyword) => {
    if (keyword && keyword !== '') {
        return `/${lowerCase(cityslug)}/${keyword}`;
    } else {
        return `/${lowerCase(cityslug)}/venues`;
    }
};

export const getDefaultQuickLinksForBaseUrl = (cityslug, url) => {
    let city = toString(cityslug).toLowerCase();
    if (getBasePageUrl(cityslug, url) === `/${city}/venues`) {
        return [
            {
                name: 'Kids Party',
                link: `/${city}/kids-party-venues`,
            },
            {
                name: 'Wedding',
                link: `/${city}/wedding-venues`,
            },
            {
                name: 'Corporate Party',
                link: `/${city}/corporate-party-venues`,
            },
            {
                name: 'Engagement',
                link: `/${city}/engagement-venues`,
            },
            {
                name: 'Birthday Party',
                link: `/${city}/birthday-party-venues`,
            },
        ];
    } else {
        return [];
    }
};

export const convertToParamObject = (array) => {
    if (Array.isArray(array)) {
        let obj = array.reduce((acc, cur, i) => {
            acc[kebabCase(cur._id)] = cur.count;
            return acc;
        }, {});
        return obj;
    } else {
        return {};
    }
};

export const localityListSearch = (array, keyword) => {
    return array.filter((value) => {
        return value?.label?.toLowerCase()?.match(new RegExp(keyword?.toLowerCase(), 'g'));
    });
};

export const whatToBeBlockedByRobotsTxt = (object) =>
    object &&
    DISALLOWED_BY_ROBOTS_TXT_KEYS.some((element) => Object.keys(object).includes(element));

export const callSearchAPI = async (url) => {
    try {
        process.env['NODE_TLS_REJECT_UNAUTHORIZED'] = '0';
        if (WHICH_SEARCH_SERVICE_TO_USE == ELASTIC_API) {
            const isOnServer = isServer();
            let basePath = '';
            if (isOnServer) {
                basePath = `${process.env.NEXT_PUBLIC_INTERNAL_APP_URL}`;
            } else {
                basePath = `${process.env.NEXT_PUBLIC_APP_URL}`;
            }
            return await callSelfAPI(`${basePath}/api/${url}`, 'get');
        } else {
            return await callApi(`${url}`, 'get');
        }
    } catch (error) {
        console.log('error in calling SEARCH API :::: ', JSON.stringify(error.data));
    }
};

export const callSearchPhotographers = async (url) => {
    try {
        process.env['NODE_TLS_REJECT_UNAUTHORIZED'] = '0';
        if (WHICH_SEARCH_SERVICE_TO_USE == ELASTIC_API) {
            const isOnServer = isServer();
            let basePath = '';
            if (isOnServer) {
                basePath = `${process.env.NEXT_PUBLIC_INTERNAL_APP_URL}`;
            } else {
                basePath = `${process.env.NEXT_PUBLIC_APP_URL}`;
            }
            return await callSelfAPI(`${basePath}/api/${url}`, 'get');
        } else {
            return await callApi(`${url}`, 'get');
        }
    } catch (error) {
        console.log('error in calling SEARCH API :::: ', error);
    }
};
export const callSearchVendors = async (url) => {
    try {
        process.env['NODE_TLS_REJECT_UNAUTHORIZED'] = '0';
        if (WHICH_SEARCH_SERVICE_TO_USE == ELASTIC_API) {
            const isOnServer = isServer();
            let basePath = '';
            if (isOnServer) {
                basePath = `${process.env.NEXT_PUBLIC_INTERNAL_APP_URL}`;
            } else {
                basePath = `${process.env.NEXT_PUBLIC_APP_URL}`;
            }
            return await callSelfAPI(`${basePath}/api/${url}`, 'get');
        } else {
            return await callApi(`${url}`, 'get');
        }
    } catch (error) {
        console.log('error in calling SEARCH API :::: ', error);
    }
};

export const checkIfSearchPageUrlValid = (cities, city_slug) => {
    const kebabCasedCity = kebabCase(city_slug.toLowerCase());
    const isValid = cities.some((city) => makeUrlValid(city?.slug) === makeUrlValid(city_slug));
    return { isValid, kebabCasedCity };
};

export const saveLastSearchedItem = (query) => {
    localStorage.setItem('rating', query?.rating || '');
    // localStorage.setItem('max_capacity', query?.max_capacity || "")
    localStorage.setItem('numberofdays', query?.numberofdays || '');
    localStorage.setItem('max_price', query?.max_price || '');
    localStorage.setItem('min_price', query?.min_price || '');
    // localStorage.setItem("min_capacity", query?.min_capacity || "")
    localStorage.setItem('reviewcount', query?.reviewcount || '');
    localStorage.setItem(
        'servicetypes',
        query?.servicetypes?.[query?.servicetypes?.length - 1] || ''
    );
    // localStorage.setItem("amenities", query?.amenities?.[query?.amenities?.length - 1] || "")
    localStorage.setItem('location', query?.location?.[query?.location?.length - 1] || '');
};

export const saveLastSearchedItemToStorage = (key, value, isSelected) => {
    if (isSelected) {
        localStorage.setItem(key, value);
    } else {
        localStorage.setItem(key, '');
    }
};

export const setLeadFormStats = (stats = {}) => {
    Object.keys(LEAD_FORM_FILTERS).forEach((key) => {
        let value = localStorage.getItem(key);
        if (value) {
            stats[LEAD_FORM_FILTERS[key]] = value;
        }
    });
    return stats;
};
export const setEnquiryFormStats = (stats = {}) => {
    Object.keys(ENQUIRY_FORM_FILTERS).forEach((key) => {
        let value = localStorage.getItem(key);
        if (value) {
            stats[ENQUIRY_FORM_FILTERS[key]] = value;
        }
    });
    return stats;
};
